import { useEffect, useState } from 'react';
import { A03, A03Output } from 'api/U005';

export interface Message {
  messageNo: number;
  message: string;
  file: string;
  isUser: boolean;
  revision: number;
  ins_dtm: Date;
}

export function useGetMessages(
  userId: string,
  auditionId: string
): [Message[], boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(true);
  const [messages, setMessages] = useState<Message[]>([]);
  const [err, setError] = useState<Error | null>(null);

  const fetchMessages = async (userId: string, auditionId: string, cancellation: AbortSignal) => {
    const json = (await A03(userId, auditionId, cancellation)) as A03Output;
    return json.messages.map((obj) => {
      return {
        messageNo: obj.message_no,
        message: obj.message,
        isUser: obj.is_user,
        file: obj.file,
        ins_dtm: new Date(obj.ins_dtm),
      } as Message;
    });
  };

  useEffect(() => {
    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      try {
        setLoading(true);
        setError(null);
        const messages = await fetchMessages(userId, auditionId, cancellation);
        setMessages(messages);
      } catch (err) {
        console.error(err);
        setError(err instanceof Error ? err : new Error(`unknown error. ${err}`));
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      controller.abort();
    };
  }, []);

  return [messages, loading, err];
}
